import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {setScreenContext} from '/redux/action/myTeams.action';

import {getReportName} from '../util/myTeamsAnalytics.util';

export const useMyTeamsScreenContext = (
  reduxIsViewTeam: boolean,
  reduxActiveTab: 'my-teams' | 'watchlist',
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const reportName = getReportName(reduxIsViewTeam, reduxActiveTab);
    dispatch(setScreenContext(reportName));
  }, [reduxIsViewTeam, reduxActiveTab, dispatch]);
};
